export default {"src":"/_next/static/media/CARE.06ab888c.svg","height":18,"width":18};